import gql from "graphql-tag";

export const UPDATE_USER_PHONE_MUTATION = gql`
  mutation UpdateUserPhone($phone: String!) {
    updateUserPhone(phone: $phone)
  }
`;
